import { createRouter } from 'stencil-router-v2';
import { h } from '@stencil/core';

export { Components, JSX } from './components';

const fallbackRouter = {
  push: (_route: string) => {},
  replace: (_route: string) => {},
  back: () => {},
  forward: () => {},
  Switch: (props: { children?: any }) => h('div', null, props.children || null),
  Route: (props: { children?: any }) => h('div', null, props.children || null),
  Redirect: () => null,
};

const createSafeRouter = () => {
  try {
    return createRouter();
  } catch (_error) {
    return fallbackRouter;
  }
};

export const Router = createSafeRouter();
